import React from 'react';
import { PageHeader } from '../../shared-components/PageHeader/PageHeader';
import { useAppSelector } from 'redux-stores';

export default function OrgName() {
  const name = useAppSelector((state) => state.orgSettings.settings.name);
  return <PageHeader label={name} />;
}
